import React from 'react'

const Achievements :React.FC = () => {
  return (
    <div>Achievements</div>
  )
}

export default Achievements